import React from "react";
import { AlertTriangle, Clock } from "lucide-react";
import { QuickStatsCard } from "@features/cx/shared/components/QuickStatsCard";

export const ReliabilityMetrics: React.FC<{ data: any }> = ({ data }) => {
  const reliabilityData = {
    portfolioFailureRate: {
      value: data?.overview?.portfolioFailureRate?.value || 0,
    },
    averageMTBF: {
      value: data?.overview?.avgMtbf?.value || 0,
      unit: "hrs",
    },
  };

  const statsData = [
    {
      title: "Portfolio Failure Rate",
      count: `${reliabilityData?.portfolioFailureRate?.value || 0}%`,
      icon: <AlertTriangle className="h-8 w-8 text-green-500" />,
      tooltip:
        "The percentage of assets within this system that have recorded a failure in the current period.",
    },
    {
      title: "Average MTBF",
      count: `${reliabilityData?.averageMTBF?.value || 0} ${reliabilityData?.averageMTBF?.unit || ""}`,
      icon: <Clock className="h-8 w-8 text-green-500" />,
      tooltip:
        "The average time that passes between one failure and the next for the assets in this system. A higher number is better.",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      {statsData.map((stat, index) => (
        <QuickStatsCard
          key={index}
          title={stat.title}
          count={stat.count}
          icon={stat.icon}
          tooltip={stat.tooltip}
        />
      ))}
    </div>
  );
};
